import React from "react";
import { ArrowRight } from "lucide-react";
import { IMAGES, NUMBERS } from "../mock";
import { useBooking } from "../App";
import Reveal from "./Reveal";

export const AboutSection = () => {
  const { openBooking } = useBooking();
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal className="relative">
          <div className="absolute -top-5 -left-5 w-28 h-28 bg-orange-brand/10 rounded-2xl -z-0" />
          <img src={`${IMAGES.facility}?w=800&q=80`} alt="Modern in-house laundry facility" className="relative rounded-2xl shadow-xl w-full h-[380px] object-cover" />
          <div className="absolute -bottom-6 -right-4 sm:right-6 bg-navy text-white rounded-2xl px-6 py-4 shadow-xl">
            <p className="text-2xl font-extrabold font-head text-orange-brand">Since 2011</p>
            <p className="text-xs text-white/70">Serving India</p>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">India's First On-Demand Service</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-navy font-head mt-2 leading-tight">
            One-Stop Solution for Laundry &amp; Dry Clean
          </h2>
          <p className="text-navy/70 mt-4 leading-relaxed">
            Laundryma is a premier on-demand garment care, dry cleaning and finishing service that caters to your personal wardrobe, shoes, bags and household products. We provide the best online dry-cleaning and laundry services with affordable pricing.
          </p>
          <p className="text-navy/70 mt-3 leading-relaxed">
            We understand the pressure of a busy life and hence provide services at your doorstep in as little as 48 hours. From traditional garments to comforters, sofas and shoes — we've got you covered, with pickup and delivery to your home or office.
          </p>
          <button onClick={openBooking} className="mt-6 inline-flex items-center gap-2 bg-orange-brand hover:bg-[#e0850f] text-white font-semibold px-7 py-3.5 rounded-full shadow-lg shadow-orange-brand/25 transition-all hover:gap-3">
            Book a Pickup <ArrowRight size={18} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export const NumbersSection = () => (
  <section className="py-14 bg-navy relative overflow-hidden">
    <div className="absolute top-0 right-0 w-72 h-72 bg-orange-brand/10 rounded-full blur-3xl" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
      <Reveal className="text-center mb-10">
        <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">Numbers Don't Lie</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-white font-head mt-2">India's #1 Laundry &amp; Dry Cleaning Chain</h2>
      </Reveal>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
        {NUMBERS.map((n, i) => (
          <Reveal key={n.label} delay={i * 60}>
            <div className="text-center">
              <p className="text-3xl sm:text-4xl font-extrabold text-orange-brand font-head">{n.value}</p>
              <p className="text-white/70 text-sm mt-1.5 font-medium">{n.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
